import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';

interface CentralBankPayment {
  pcb_id: number;
  pcb_account: string;
  pcb_value_date: string;
  pcb_amount: number;
  pcb_debtor_name: string;
  pcb_description: string;
  pcb_status_code: number;
  pcb_error: string;
  pcb_status_desc: string;
}

interface Paging {
  page: number;
  pageSize: number;
  total: number;
}
interface CentralBankPaymentListData {
  paging: Paging;
  items: CentralBankPayment[];
}

interface CentralBankPaymentListOutput {
  status: StateStatus;
  data: CentralBankPaymentListData | null;
}

export const useGetCentralBankPaymentList =
  (): CentralBankPaymentListOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.CENTRAL_BANK_PAYMENT_LIST_REDUCER]
          .centralBankPaymentList
    );
    return data;
  };

interface IStatusCodes {
  statusCode: number;
  statusDesc: string;
}

interface CentralBankPaymentStatusCodesOutput {
  data: IStatusCodes[];
}

export const useGetCentralBankPaymentStatusCodes =
  (): CentralBankPaymentStatusCodesOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.CENTRAL_BANK_PAYMENT_LIST_REDUCER]
          .centralBankPaymentStatusCodesList
    );
    return data;
  };

interface IAccounts {
  pcb_account: string;
}
interface CentralBankPaymentAccountsOutput {
  data: IAccounts[];
}

export const useGetCentralBankPaymentAccounts =
  (): CentralBankPaymentAccountsOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.CENTRAL_BANK_PAYMENT_LIST_REDUCER]
          .centralBankPaymentAccountsList
    );
    return data;
  };

export const useUpdateCentralBankPaymentStatus = () => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.CENTRAL_BANK_PAYMENT_LIST_REDUCER]
        .updateCentralBankPaymentStatus
  );

  return data;
};

export const useFetchCentralBankPayments = () => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.CENTRAL_BANK_PAYMENT_LIST_REDUCER]
        .fetchCentralBankPayments
  );

  return data;
};

export const useMatchCentralBankPayments = () => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.CENTRAL_BANK_PAYMENT_LIST_REDUCER]
        .matchCentralBankPayments
  );

  return data;
};
